@if (isLoading()) {
  <app-spinner class="h-100 radius-plus"></app-spinner>
}
<div class="w-100 d-flex gap-minus justify-content-space-between flex-wrap radius-plus surface-elevated px-plus py-big">
  <div class="w-100 d-flex align-items-center justify-content-space-between gap-small">
    <div class="d-flex align-items-center">
      <span class="b-2 text-onback-medium">کل دارایی شما</span>
      <ngx-button
        [mode]="'icon-only'"
        (clickHandler)="canSee.set(!canSee())"
        [style]="'neutral-link'"
        [size]="'small'"
        [leftIcon]="{
          name: canSee() ? 'hide' : 'eye',
          type: canSee() ? 'bold' : 'linear',
        }"
      >
      </ngx-button>
    </div>

    <ngx-button
      [style]="'link'"
      [size]="'small'"
      [leftIcon]="{
        name: 'arrow-2-left',
      }"
      (clickHandler)="goToPortfo()"
    >
      سبد دارایی
    </ngx-button>
  </div>
  <div
    (click)="hideDetail.set(!hideDetail())"
    class="w-100 position-relative"
  >
    <div class="w-100">
      @if (canSee()) {
        <div class="d-flex align-items-center gap-tiny">
          <span class="st-1 text-onback-medium">
            {{ portfolio()?.balance | number }}
          </span>
          <div class="b-2 text-onback-medium is-currency">ریال</div>
        </div>
      } @else {
        <span class="st-1 text-onback-medium">********</span>
      }
    </div>
    @if (canSee()) {
      <div class="w-100 d-flex align-items-center last-update">
        <p class="l-3 text-onback-low ml-small">
          @if (!isLoadingNewData()) {
            آخرین به‌روز رسانی: {{ portfolio()?.persianLastUpdatedAt }}
          } @else {
            در حال به‌روز رسانی دارایی
          }
        </p>
        @if (isLoadingNewData()) {
          <ngx-spinner
            size="sm"
            color="primary"
          ></ngx-spinner>
        } @else {
          <ngx-icon
            class="cursor-pointer text-oninvert-brand"
            [name]="'refresh'"
            [type]="'bold'"
            [iconSize]="'18px'"
            (click)="updateData()"
          />
        }
      </div>
    }
  </div>
  @if (portfolio()?.orderInProgressCount > 0) {
    <div class="w-100 d-flex align-items-center radius-big mt-medium px-medium py-small surface-back">
      <div class="w-50">
        <p class="text-onback-medium c-3">در حال سرمایه‌گذاری ...</p>
      </div>
      <div class="w-50 d-flex justify-content-end align-items-center gap-tiny">
        <ngx-badge
          size="sm"
          status="warning"
          mode="bold"
          type="count"
          classList="text-oninvert-high"
        >
          {{ portfolio().orderInProgressCount || 1 }}
        </ngx-badge>
        <ngx-button
          [mode]="'icon-only'"
          [style]="'neutral-link'"
          [size]="'tiny'"
          [rightIcon]="{
            name: 'arrow-2-left',
            type: 'linear',
          }"
          (clickHandler)="pendingTransactions()"
        />
      </div>
    </div>
  }
</div>
